import React from "react";
import {useState,useEffect} from "react";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Tag} from "primereact/tag";
import {Divider} from "primereact/divider";
import {TabView,TabPanel} from "primereact/tabview";
import {Tooltip} from "primereact/tooltip";
import Message from "../Helpers/Message.js";
import {fetch_url_post} from "../../Sources/js/app.js";

const formatDataRO = (str) => {
	if (!str) return '';
	const luni = ['Ian','Feb','Mar','Apr','Mai','Iun','Iul','Aug','Sep','Oct','Nov','Dec'];
	const d = new Date(str.replace(' ', 'T'));
	if (isNaN(d)) return str;
	return String(d.getDate()).padStart(2,'0') + '-' + luni[d.getMonth()] + '-' + d.getFullYear();
};

let oper = "";

let defaultOauthValues = {
	has_token: 0,
	token_expires_at: "",
};

let defaultDialogValues = {
	openDetails: false,
	titleDetails: "",
};

const EFacturi = (props) => {

	const [oauthValues, setOauthValues] = useState(defaultOauthValues);
	const [efacturiList, setEfacturiList] = useState([]);
	const [selectedEfactura, setSelectedEfactura] = useState(null);
	const [selectedRows, setSelectedRows] = useState([]);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [blockScreen, setBlockScreen] = useState(false);
	const [filterText, setFilterText] = useState("");
	const [filterStatus, setFilterStatus] = useState("");
	const [zile, setZile] = useState("5");
	const [showImportate, setShowImportate] = useState(false);

	const success_handler = (result) => {
		setBlockScreen(false);
		if(result.ok === 0) {
			setMessageText("Eroare: " + result.error);
			return false;
		}
		if(result.is_auth === 0) {
			window.location.href = "/login";
			return false;
		}
		if(result.message) {
			setMessageText(result.message);
		}
		if(oper === "getEFacturaOauth") {
			if(result.data) {
				setOauthValues({has_token: result.data.has_token || 0, token_expires_at: result.data.token_expires_at || ""});
			}
			loadEfacturi();
		}
		if(oper === "getEFacturi" || oper === "fetchEFacturiAnaf" || oper === "downloadEFactura" || oper === "importEFactura" || oper === "bulkImportEFacturi" || oper === "bulkDownloadEFacturi") {
			if(result.efacturiList) {
				setEfacturiList(result.efacturiList);
			}
		}
		if(oper === "downloadEFactura") {
			if(result.data && result.data.ok) {
				setSelectedEfactura(result.data);
				setDialogValues({...dialogValues, openDetails: true, titleDetails: "Detalii factura " + (result.data.numar_factura || "")});
			}
		}
		setDataOk(true);
		oper = "";
	}

	const fail_handler = () => {
		setBlockScreen(false);
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	useEffect(() => {
		loadOauthConfig();
	}, []);

	const loadOauthConfig = () => {
		oper = "getEFacturaOauth";
		let url = "getEFacturaOauth?session_id=" + props.session.sessId;
		fetch_url_post(url, {}, success_handler, fail_handler);
	}

	const loadEfacturi = (showImp) => {
		oper = "getEFacturi";
		let url = "getEFacturi?session_id=" + props.session.sessId;
		setBlockScreen(true);
		let _showImp = showImp !== undefined ? showImp : showImportate;
		fetch_url_post(url, {filter_text: filterText, filter_status: filterStatus, show_importate: _showImp ? 1 : 0}, success_handler, fail_handler);
	}

	const toggleShowImportate = () => {
		let newVal = !showImportate;
		setShowImportate(newVal);
		loadEfacturi(newVal);
	}

	const handleFetchFromAnaf = () => {
		if(!oauthValues.has_token) {
			setMessageText("Nu sunteti autentificat la ANAF. Configurati din meniul Date Unitate.");
			return;
		}
		oper = "fetchEFacturiAnaf";
		let url = "fetchEFacturiAnaf?session_id=" + props.session.sessId;
		setBlockScreen(true);
		fetch_url_post(url, {zile: parseInt(zile)}, success_handler, fail_handler);
	}

	const handleDownloadDetails = (row) => {
		oper = "downloadEFactura";
		let url = "downloadEFactura?session_id=" + props.session.sessId;
		setBlockScreen(true);
		fetch_url_post(url, {anaf_id: row.anaf_id}, success_handler, fail_handler);
	}

	const handleImport = (row) => {
		if(!window.confirm("Importati aceasta factura in Registrul de intrari?")) return;
		oper = "importEFactura";
		let url = "importEFactura?session_id=" + props.session.sessId;
		setBlockScreen(true);
		fetch_url_post(url, {cache_id: row.id}, success_handler, fail_handler);
	}

	const handleBulkImport = () => {
		const toImport = selectedRows.filter(r => r.status !== 'IMPORTAT');
		if(toImport.length === 0) {
			setMessageText("Selectati cel putin o factura neimportata!");
			return;
		}
		if(!window.confirm("Importati " + toImport.length + " facturi selectate in Registrul de intrari?")) return;
		oper = "bulkImportEFacturi";
		let url = "bulkImportEFacturi?session_id=" + props.session.sessId;
		setBlockScreen(true);
		fetch_url_post(url, {cache_ids: toImport.map(r => r.id)}, success_handler, fail_handler);
	}

	const handleBulkDownload = () => {
		oper = "bulkDownloadEFacturi";
		let url = "bulkDownloadEFacturi?session_id=" + props.session.sessId;
		setBlockScreen(true);
		fetch_url_post(url, {}, success_handler, fail_handler);
	}

	const statusTemplate = (row) => {
		const colors = {
			"NOU": "info",
			"DESCARCAT": "warning",
			"IMPORTAT": "success",
		};
		return <Tag value={row.status} severity={colors[row.status] || "secondary"} style={{fontSize:"10px"}}/>;
	}

	const actionsTemplate = (row) => (
		<React.Fragment>
			<Button icon="pi pi-eye" className="p-button-sm p-button-info p-button-text"
				tooltip="Vizualizeaza detalii" tooltipOptions={{position:"top"}}
				style={{marginRight:"2px"}}
				onClick={() => handleDownloadDetails(row)}/>
			{row.status === "IMPORTAT" ?
				<Tag value={"Reg. " + (row.registru_nr || "#"+row.registru_id)} severity="success"
					style={{fontSize:"10px", cursor:"default"}}
					tooltip="Deja importata in registru" tooltipOptions={{position:"top"}}/>
				:
				<Button icon="pi pi-download" className="p-button-sm p-button-success p-button-text"
						tooltip="Importa in Registrul de intrari" tooltipOptions={{position:"top"}}
						onClick={() => handleImport(row)}/>
			}
		</React.Fragment>
	);

	const totalTemplate = (row) => (
		<span style={{fontWeight:"bold"}}>
			{row.total ? parseFloat(row.total).toFixed(2) : "-"} {row.moneda || "RON"}
		</span>
	);

	const furnizorTemplate = (row) => {
		if(row.denumire_emitent) return <span>{row.denumire_emitent}</span>;
		if(row.cif_emitent) return <span style={{color:"#888", fontStyle:"italic"}}>CIF: {row.cif_emitent}</span>;
		return <span style={{color:"#ccc"}}>-</span>;
	};

	return(
		<BlockUI blocked={blockScreen} fullScreen>
			{!!(!dataOk) && <LinearProgress/>}
			{messageText && <Message text={messageText} closeHandler={() => setMessageText(null)}/>}

			<Grid container spacing={1} style={{padding:"8px"}}>
				{/* Toolbar */}
				<Grid item xs={12}>
					<div style={{display:"flex", gap:"6px", alignItems:"center", flexWrap:"wrap", marginBottom:"8px"}}>
						{/* OAuth status badge */}
						<Tag
							value={oauthValues.has_token ? "ANAF: Autentificat" : "ANAF: Neautentificat"}
							severity={oauthValues.has_token ? "success" : "danger"}
							style={{marginRight:"8px"}}/>
					{oauthValues.has_token && oauthValues.token_expires_at &&
						<span style={{fontSize:"12px", color:"#555", fontWeight:"bold", marginRight:"8px"}}>
							Expira: {formatDataRO(oauthValues.token_expires_at)}
						</span>
					}
						{!oauthValues.has_token &&
							<span style={{fontSize:"12px", color:"#888"}}>
								<i className="pi pi-info-circle" style={{marginRight:"4px"}}/>
								Configurati din <a href="/#/unitData" style={{color:"#1976d2"}}>Date Unitate</a>
							</span>
						}
						{!!oauthValues.has_token &&
							<React.Fragment>
								<InputText value={zile} onChange={(e) => setZile(e.target.value)}
									style={{width:"70px"}} className="p-inputtext-sm"
									tooltip="Numar de zile (max 10-11 zile pentru aceasta institutie)" tooltipOptions={{position:"top"}}/>
								<span style={{fontSize:"12px", color:"#666"}}>zile</span>
								<Button label="Preia de la ANAF" icon="pi pi-cloud-download"
									className="p-button-sm p-button-info p-button-raised"
									onClick={handleFetchFromAnaf}/>
								<Button label="Descarca XML-uri" icon="pi pi-file-arrow-down"
									className="p-button-sm p-button-secondary p-button-raised"
									tooltip="Descarca pe server XML-urile pentru toate facturile nedescarcate"
									tooltipOptions={{position:"bottom"}}
									onClick={handleBulkDownload}/>
							</React.Fragment>
						}
						{selectedRows.length > 0 &&
							<Button
								label={"Import selectate (" + selectedRows.filter(r=>r.status!=='IMPORTAT').length + ")"}
								icon="pi pi-download"
								className="p-button-sm p-button-success p-button-raised"
								onClick={handleBulkImport}/>
						}
						<span style={{marginLeft:"auto", display:"flex", gap:"6px", alignItems:"center"}}>
							<Button
								label={showImportate ? "Ascunde facturi inregistrate" : "Afisare facturi vechi"}
								icon={showImportate ? "pi pi-eye-slash" : "pi pi-history"}
								className={"p-button-sm p-button-raised " + (showImportate ? "p-button-warning" : "p-button-secondary")}
								onClick={toggleShowImportate}/>
							<InputText placeholder="Filtru: furnizor / nr. factura" value={filterText}
									onChange={(e) => setFilterText(e.target.value)}
									style={{width:"200px"}} className="p-inputtext-sm"/>
							<Button label="Cauta" icon="pi pi-search"
									className="p-button-sm p-button-info p-button-raised"
									onClick={() => loadEfacturi()}/>
						</span>
					</div>
				</Grid>

				{/* E-facturi table */}
				<Grid item xs={12}>
					<DataTable value={efacturiList} paginator rows={50}
							rowsPerPageOptions={[25,50,100]}
						emptyMessage="Nu exista e-facturi. Apasati 'Preia de la ANAF' pentru a sincroniza."
						className="p-datatable-sm"
						sortField="anaf_id" sortOrder={1}
						selection={selectedRows}
						onSelectionChange={(e) => setSelectedRows(e.value)}
						dataKey="id"
						style={{fontSize:"13px"}}>
							<Column selectionMode="multiple" style={{width:"40px"}}/>
							<Column field="anaf_id" header="ID ANAF" sortable style={{width:"120px", fontSize:"11px"}}/>
							<Column field="denumire_emitent" header="Furnizor / Emitent" body={furnizorTemplate} sortable style={{width:"200px", maxWidth:"200px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}/>
						<Column field="cif_emitent" header="CIF Furnizor" sortable style={{width:"110px"}}/>
						<Column field="numar_factura" header="Nr. Factura" sortable style={{width:"130px"}}/>
						<Column field="data_factura" header="Data Factura" sortable style={{width:"120px"}}/>
						<Column field="total" header="Total" body={totalTemplate}
							sortable style={{width:"110px", textAlign:"right"}}/>
						<Column field="status" header="Status" body={statusTemplate} style={{width:"100px"}}/>
						<Column header="Actiuni" body={actionsTemplate} style={{width:"90px"}}/>
					</DataTable>
				</Grid>
			</Grid>

			{/* Invoice Details Dialog */}
			<Dialog header={dialogValues.titleDetails} visible={dialogValues.openDetails}
				style={{width:"780px"}} modal
				onHide={() => setDialogValues({...dialogValues, openDetails: false})}>
				{selectedEfactura &&
					<div style={{padding:"8px"}}>
						<Grid container spacing={1}>
							<Grid item xs={6}>
								<strong>Furnizor:</strong> {selectedEfactura.furnizor}<br/>
								<strong>CIF Furnizor:</strong> {selectedEfactura.furnizor_cui}<br/>
								<strong>Cumparator:</strong> {selectedEfactura.cumparator}
							</Grid>
							<Grid item xs={6}>
								<strong>Nr. Factura:</strong> {selectedEfactura.numar_factura}<br/>
								<strong>Data:</strong> {selectedEfactura.data_factura}<br/>
								<strong>Moneda:</strong> {selectedEfactura.moneda}
							</Grid>
							<Grid item xs={12}>
								<Divider/>
							</Grid>
						</Grid>

						{selectedEfactura.items && selectedEfactura.items.length > 0 &&
							<DataTable value={selectedEfactura.items} className="p-datatable-sm"
								style={{fontSize:"12px", marginBottom:"12px"}}>
								<Column field="cod" header="Cod" style={{width:"90px"}}/>
								<Column field="denumire" header="Denumire produs/serviciu"/>
								<Column field="cantitate" header="Cant." style={{width:"70px"}}/>
								<Column field="um" header="U.M." style={{width:"60px"}}/>
								<Column field="pret_unitar" header="Pret unitar"
									body={(row) => parseFloat(row.pret_unitar || 0).toFixed(2)}
									style={{width:"100px", textAlign:"right"}}/>
								<Column field="tva_procent" header="TVA %"
									body={(row) => (row.tva_procent || 0) + "%"}
									style={{width:"70px", textAlign:"right"}}/>
								<Column field="total_linie" header="Total"
									body={(row) => parseFloat(row.total_linie || 0).toFixed(2)}
									style={{width:"100px", textAlign:"right"}}/>
							</DataTable>
						}

						<div style={{textAlign:"right", borderTop:"1px solid #ddd", paddingTop:"8px"}}>
							<span style={{marginRight:"20px"}}>
								<strong>Valoare fara TVA:</strong> {parseFloat(selectedEfactura.valoare || 0).toFixed(2)} {selectedEfactura.moneda}
							</span>
							<span style={{marginRight:"20px"}}>
								<strong>TVA:</strong> {parseFloat(selectedEfactura.tva || 0).toFixed(2)} {selectedEfactura.moneda}
							</span>
							<span style={{fontSize:"15px"}}>
								<strong>TOTAL: {parseFloat(selectedEfactura.total || 0).toFixed(2)} {selectedEfactura.moneda}</strong>
							</span>
						</div>
					</div>
				}
			</Dialog>
		</BlockUI>
	);
}

export default EFacturi;
